export const ERROR_OCCURED = 'error/ERROR_OCCURED';

export const errorOccured = (payload = {}) => ({
  type: ERROR_OCCURED,
  payload,
});
